<template>
  <Tile
    :title="pluraliseString('Future Appointment', entries.length)"
    :entries="entries"
    :selected="selected"
    :tooltip="tooltip || 'Future appointments are restricted to the next 5 upcoming appointments'"
  >
    <template #count>
      {{ commaNumber(entries.length) }} {{ entries.length >= 5 ? '+' : '' }}
    </template>
  </Tile>
</template>

<script>
import Tile from 'components/partials/timeline/partials/Tile'
import tileMixin from 'components/partials/timeline/partials/tileMixin'

export default {
  components: {
    Tile
  },
  mixins: [tileMixin],
  computed: {
    figures () {
      // const figures = {}
      return {}
    }
  }
}
</script>
